import React from 'react';
import FunctionsContext from './FunctionsContext'
import styled from 'styled-components';
import { Button, Stepper, Step, StepLabel, Divider } from '@material-ui/core';
import FunctionsFormMenu from './FunctionsFormMenu';


const SubContainer = styled.div`
    display:grid;
    height:72px;
    width:100%;
    background:#ffffff;
    grid-template-columns:1fr 200px;

`;


const Container = styled.div`
    width:100%;

`;


const StepsContainer = styled.div`
`;


const ButtonContainer = styled.div`
    display:flex;
    align-items:center;
    justify-content:center;
    margin-right:5px;
`;

class FunctionsList extends React.Component {

    static contextType = FunctionsContext;
    render() {
        const { workflowSteps = [] } = this.context.functions.selectedFunctionDetails;
        const currentUser = this.context.aboutCurrentUser;
        const currentOmFunctions = currentUser.permissions.filter(x => x.hasRole === true && x.scope === 'FUNC' && x.assetId).map(t => t.assetId);
        let onlyOMorAdminCanSee = ((currentUser.isOM && currentOmFunctions.some(x => x === this.context.functions.selectedFunction.id)) || currentUser.isAdmin);

        return (
            <Container>

                <>
                    <SubContainer>
                        <StepsContainer >
                            <Stepper activeStep={null}>
                                {workflowSteps.map((workflowStep, index) => <Step key={index}>
                                    <StepLabel>{workflowStep.stepLabel}</StepLabel>
                                </Step>)}
                            </Stepper>
                        </StepsContainer>
                        {onlyOMorAdminCanSee === true && (<ButtonContainer>
                            <FunctionsFormMenu />
                            {/* <Button style={{marginRight:5}} onClick={()=>this.context.displayFunctionNotificationDialog()} variant="contained" color="primary">
                    NOTIFICATIONS
                </Button>   
                    
                <Button onClick={()=>this.context.displayWorkflowDialog()} variant="contained" color="primary">
                    WORKFLOW
                </Button> */}
                        </ButtonContainer>)}
                    </SubContainer>
                </>
                <Divider />
            </Container>)
    }
}
export default FunctionsList;